<template>
  <div id="app">
    <section class="section">
      <div class="columns is-desktop">
        <div class="column is-2">
          <div class="tile is-ancestor">
            <div class="tile is-parent is-vertical">
              <TileToken v-on:loggedin="update()"></TileToken>
              <TileInfo></TileInfo>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="tile is-ancestor">
            <div class="tile is-parent is-vertical">
              <TileMemberInfo v-bind:member-info="memberinfo"></TileMemberInfo>
              <TileChangePrefix></TileChangePrefix>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="tile is-ancestor">
            <div class="tile is-parent is-vertical">
              <tile-music v-if="isInMusicChannel" v-bind:musicobj="musicobj"></tile-music>
            </div>
          </div>          
        </div>
        <div class="column"></div>
      </div>
    </section>
  </div>
</template>

<script>
import TileToken from './components/TileToken.vue'
import TileMemberInfo from './components/TileMemberInfo.vue'
import TileInfo from './components/TileInfo.vue'
import TileChangePrefix from './components/TileChangePrefix.vue'
import TileMusic from './components/TileMusic.vue'

export default {
  name: 'app',
  data: function() {
    return {
      memberinfo: { 
        name: 'USERNAME',
        onlineStatus: 'OFFLINE',
        tag: '1234'
      },
      musicobj: {
            "queue": [],
            "hasPlayer": true,
            "idle": false,
            "currentTrackInformation": {
                "length": 216001,
                "position": 37140,
                "uri": "uri",
                "author": "",
                "title": "Currently No Track Playing"
            }
        },
      musicobjdefault: {
            "queue": [],
            "hasPlayer": true,
            "idle": false,
            "currentTrackInformation": {
                "length": 216001,
                "position": 37140,
                "uri": "uri",
                "author": "",
                "title": "Currently No Track Playing"
            }
        },
      isInMusicChannel: false
    }
  },
  components: {
    TileToken,
    TileMemberInfo,
    TileInfo,
    TileChangePrefix,
    TileMusic
  },
  methods: {
    update: function() {
      
      this.axios.get(this.$store.state.adress + '/getMemberInfo?token=' + this.$store.state.token)
      .then((response) => {
        console.log(response.data);
        this.memberinfo = response.data.object;
      })
      setInterval(this.updateMusic, 500)
    },
    updateMusic() {
      this.axios.get(this.$store.state.adress + '/music?token=' + this.$store.state.token)
      .then((response) => {
        console.log(response.data);
        if (response.data.object == false) {
          
          this.isInMusicChannel = false;

        } else {

          this.isInMusicChannel = true;
          if (response.data.object.currentTrackInformation == null) this.musicobj = this.musicobjdefault;
          else this.musicobj = response.data.object;
        }
      })
    }
  }
}
</script>

<style>
@import "~bulma/css/bulma.css";
</style>
